import styled, { css } from 'styled-components';

import { NavBarwidth } from 'const';

import bkImg from 'ui/assets/img/background-1-def-inner-webapp.webp';
import bkImgRotated from 'ui/assets/img/background-1-def-inner-webapp.webp';
import { pxToRem } from 'utils/scss';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  position: relative;
  height: 100vh;
  width: ${({ vW }) => `calc(${vW} * 100)`};
  overflow-x: hidden;
  background: ${props =>
    props.rotated ? `url(${bkImgRotated})` : `url(${bkImg})`};
  background-position: top left;
  background-size: cover;
  background-repeat: no-repeat;

  @media ${props => props.theme.device.tabletL} {
    margin-left: 0;
    width: 100vw;
  }
`;

export const PageContent = styled.div`
  background: ${props => props.theme.colors.backgroundOpacity};
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  min-width: calc(100vw - ${pxToRem(NavBarwidth)});
  margin-left: ${pxToRem(NavBarwidth)};
  padding: 24px 32px 60px 32px;
  overflow: auto;
  position: relative;
  flex-grow: 1;
  width: 100%;
  transition: all 250ms ease-in-out;

  @media ${props => props.theme.device.tablet} {
    min-width: calc(100vh - ${pxToRem(NavBarwidth)});
    margin-left: ${pxToRem(NavBarwidth)};
  }

  ${props =>
    props.isOnDashboard &&
    css`
      background: transparent;
    `}
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${pxToRem('32px')};
`;
